export class Video {
  idVideo: number;
  tituloProyectoVideo: string;
  descripcionVideo: string;
  empresaVideo: string;
  fechaVideo: string;
  imagenVideo: string;
  tituloDetalle: string;
  descripcionDetalle: string;
  insertVideo: string;
  porcentajeGrabacion: string;
  porcentajePremiere: string;
  porcentajeFinalCut: string;
  porcentajePosproduccion: string;
}
